import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const e = i((a, s) => /* @__PURE__ */ l.jsx(
  r,
  {
    ref: s,
    ...a,
    image: (h) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...h,
        children: [
          /* @__PURE__ */ l.jsxs("g", { fill: "currentColor", clipPath: "url(#clip0_3410_69100)", children: [
            /* @__PURE__ */ l.jsx("path", { d: "m15.707 3.293-3-3-1.414 1.414L12.586 3h-1.368a5 5 0 0 0-4.022 2.03L4.424 9.446l-.003-.001-.094.15a3 3 0 0 1-2.545 1.411H0v2h1.782a5 5 0 0 0 4.241-2.351l.477-.764.477.764a5 5 0 0 0 4.241 2.351h1.36l-1.285 1.286 1.414 1.414 2.995-2.994.004-.004v-.001a1 1 0 0 0 .001-1.415l-3-3-1.414 1.414 1.3 1.3h-1.375a3 3 0 0 1-2.545-1.41L7.68 8.003l.994-1.593a3 3 0 0 1 2.545-1.41h1.368l-1.293 1.292 1.414 1.414 3-3a1 1 0 0 0 0-1.414" }),
            /* @__PURE__ */ l.jsx("path", { d: "M1.782 3a5 5 0 0 1 4.134 2.188l-1.18 1.88-.41-.657a3 3 0 0 0-2.544-1.41H0V3z" })
          ] }),
          /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_3410_69100", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
e.displayName = "ShuffleIcon";
export {
  e as ShuffleIcon,
  e as default
};
//# sourceMappingURL=index.js.map
